import { BceHomeComponent } from './bce-home/bce-home.component';
import { LoadingPageComponent } from '@morningstar/wsg/shared';
import { Error404Component } from './error404/error404.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SplashPageComponent } from './splash-page/splash-page.component';
import { NavigationGuardModule } from './navigation-guard/navigation-guard.module';
import { PrivacyComponent } from './privacy/privacy.component';

const routes: Routes = [
  { path: 'admin', loadChildren: () => import('../app/admin/admin.module').then(m => m.AdminModule)},
  { path: 'client', loadChildren: () => import('../app/client/client.module').then(m => m.ClientModule)},
  { path: 'check-in', loadChildren: () => import('../app/check-in/check-in.module').then(m => m.CheckInModule)},
  { path: 'geek-pay', loadChildren: () => import('../../../../libs/wsg/geek-pay-anonymous/src/lib/wsg-geek-pay-anonymous.module').then(m => m.WsgGeekPayAnonymousModule)},
  { path: 'invoice', loadChildren: () => import('../app/invoice/invoice.module').then(m => m.InvoiceModule)},
  { path: 'ledger', loadChildren: () => import('../app/ledger/ledger.module').then(m => m.LedgerModule)},
  { path: 'network', loadChildren: () => import('../app/network/network.module').then(m => m.NetworkModule)},
  { path: 'payments', loadChildren: () => import('../app/payments/payments.module').then(m => m.PaymentsModule)},
  { path: 'privacy', component: PrivacyComponent },
  { path: 'prospects', loadChildren: () => import('../app/prospects/prospects.module').then(m => m.ProspectsModule)},
  { path: 'reports', loadChildren: () => import('../app/reports/reports.module').then(m => m.ReportsModule)},
  { path: 'resource', loadChildren: () => import('../app/resource/resource.module').then(m => m.ResourceModule)},
  { path: 'scheduler', loadChildren: () => import('../app/scheduler-home/scheduler-home.module').then(m => m.SchedulerHomeModule)},
  { path: 'settings', loadChildren: () => import('../app/settings/settings.module').then(m => m.SettingsModule)},
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  { path: 'splash-page', component: SplashPageComponent },
  { path: 'bce-home', component: BceHomeComponent },
  { path: 'loading', component: LoadingPageComponent },
  { path: '', component: HomeComponent },
  { path: '**', component: Error404Component }
];

@NgModule({
    imports: [
      NavigationGuardModule,
      RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
